import styled from "styled-components";
import background from "../../res/image/corzoneso.jpg";
import { CorzTextField } from "../components/form/TextField";
import { FilledButton } from "../components/buttons/CommonButton";
import { Divider } from "../components/Components";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

const LoginContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	height: 100vh;
	background-image: url(${background});
	background-size: cover;
	background-position: center;
`;

const ExplainContent = styled.div`
	position: relative;
	width: 65%;
	height: 100vh;
	padding: 96px;
	display: flex;
	flex-direction: column;
	gap: 24px;

	h1,
	p {
		color: #1b1b1f;
	}

	@media (max-width: 768px) {
		padding: 96px 64px;
		width: 35%;
	}

	@media (max-width: 480px) {
		display: none;
		padding: 24px;
		width: 100%;
		height: auto;
	}
`;

const FormContent = styled.div`
	position: relative;
	padding: 24px;
	display: flex;
	flex-direction: column;
	flex: 1 1;
	justify-content: center;
	align-items: center;
	gap: 24px;
	background-color: var(--color-background);
	transition: 0.3s;

	/*@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
		-webkit-backdrop-filter: blur(6px);
		backdrop-filter: blur(6px);
		background: var(--color-dialog);
	}*/

	form {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}
`;

const Space = styled.div`
	flex: 1 1 auto;
`;

export default function LoginPage({ auth }) {
	const navigate = useNavigate();
	const emailRef = useRef();
	const passwordRef = useRef();

	const handleLoginFormSend = (e) => {
		e.preventDefault(); // Logica per gestire l'invio del form di login

		// Ottieni i valori degli input 
		const email = emailRef.current.getValue().trim(); 
		const password = passwordRef.current.getValue().trim();
		
		console.log("Email:", email);
		console.log("Password:", password);

		let error = false;

		if (email === "") {
			emailRef.current.updateError(true, "Riempi questo campo");
			error = true;
		}

		if (password === "") {
			passwordRef.current.updateError(true, "Riempi questo campo");
			error = true;
		}

		if (error) return;

		signInWithEmailAndPassword(auth, `${email}@corz.ch`, password)
			.then((userCredential) => {
				// Signed up
				// const user = userCredential.user;
				// ...
			})
			.catch((error) => {
				const errorCode = error.code;
				const errorMessage = error.message;

				console.error(errorCode, errorMessage);

				if (errorCode === "auth/invalid-email") {
					emailRef.current.updateError(true, "Email non valida");
				} else if (errorCode === "auth/user-not-found") {
					emailRef.current.updateError(true, "Utente non trovato");
				} else if (errorCode === "auth/wrong-password") {
					passwordRef.current.updateError(true, "Password errata");
				} else {
					emailRef.current.updateError(
						true,
						"Autenticazione non valida"
					);
					passwordRef.current.updateError(
						true,
						"Autenticazione non valida"
					);
				}
			});
	};

	const handleGuestButtonClick = (e) => {
		e.preventDefault(); 
		navigate("/visitatore");
	};

	return (
		<LoginContainer>
			<ExplainContent>
				<h1>Casa Corzoneso Valsecchi</h1>
				<p>
					Ciao e benvenuto al sito della casa a Corzoneso della
					famiglia Valsecchi! Se hai un login, puoi accedere con le
					tue credenziali e usufruire di tutti i servizi e le
					funzionalità del sito. Se invece non hai un login, puoi
					accedere come ospite e visitare le sezioni pubbliche del
					sito. Ti auguriamo una buona navigazione!
				</p>
			</ExplainContent>
			<FormContent>
				<h2>Login utenti registrati</h2>
				<Space />
				<form onSubmit={handleLoginFormSend} noValidate>
					<CorzTextField
						ref={emailRef}
						id="email"
						label="Email"
						type="text"
						required={true}
						suffixText="@corz.ch"
					/>
					<CorzTextField
						ref={passwordRef}
						id="password"
						label="Password"
						type="password"
						required={true}
					/>
					<FilledButton text="Login" type="submit" />
					<Divider />
					<FilledButton
						text="Visita come ospite"
						onClick={handleGuestButtonClick}
						theme="secondary"
						type="button"
					/>
				</form>
				<Space />
			</FormContent>
		</LoginContainer>
	);
}
